import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Subject } from 'rxjs';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, map } from 'rxjs/operators';

@Component({
  selector: 'auth-layout',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AuthLayoutComponent implements OnDestroy, OnInit {
  title: string = 'Продвижение без забот';
  description: string = 'Реклама в социальных сетях и мессенджерах — это современный способ продвижения товаров и услуг, недорогой и эффективный.';

  private _unsubscribeAll: Subject<any> = new Subject<any>();

  /**
   * Constructor
   */
  constructor(private router: Router, private route: ActivatedRoute) {}

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  ngOnInit(): void {
    this.updateTitleAndDescription(this.route);

    // Обновление данных при смене маршрута
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => this.route)
      )
      .subscribe((route) => this.updateTitleAndDescription(route));
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  private updateTitleAndDescription(route: ActivatedRoute): void {
    let child = route.firstChild;
    while (child?.firstChild) {
      child = child.firstChild;
    }
    const data = child?.snapshot.data;

    this.title = data?.title || 'Продвижение без забот';
    this.description = data?.description ||
      'Реклама в социальных сетях и мессенджерах — это современный способ продвижения товаров и услуг, недорогой и эффективный.';
  }
}
